/**
 * URL parameters parsed once at module load.
 * These values are read-only after initialization.
 */
import { getTypedVal } from "../utils/urls";

// Standalone mode params - parsed once, never change at runtime
export const STANDALONE_ARTICLE = getTypedVal("rlx_search_item", "");
export const STANDALONE_ARTICLE_ID = getTypedVal("fsc_article_id", "");
